import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  height: calc(100vh - 14vh);
  height: calc(100dvh - 14dvh);
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
  @media (max-width: 900px) {
    height: calc(100vh - 8vh);
    height: calc(100dvh - 8dvh);
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  height: calc(100vh - 182px);
  height: calc(100dvh - 182px);
  display: flex;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px 0 50px 0px;
  justify-content: center;
  h1 {
    text-align: center;
  }
  z-index: 1;
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ButtonP5 = styled.button`
  width: 100%;
  height: 39px;
  background: var(--color-broccoli);
  font-size: 16px;
  color: var(--color-white);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 10px;
`;

export const ContainerButton = styled.div`
  position: relative;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 30px;
`;

export const ContainerSinTurno = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 35px;
  margin-top: 81px;
  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
  .subtitle {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
`;

export const CardOrden = styled.div`
  width: 340px;
  height: auto;
  background: var(--color-white);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  text-align: left;
  /* border: 1px solid var(--color-black); */
  box-shadow: rgba(0, 0, 0, 0.05) 0px 41.7776px 33.4221px,
    rgba(0, 0, 0, 0.043) 0px 22.3363px 17.869px,
    rgba(0, 0, 0, 0.035) 0px 12.5216px 10.0172px,
    rgba(0, 0, 0, 0.027) 0px 6.6501px 5.32008px,
    rgba(0, 0, 0, 0.02) 0px 2.76726px 2.21381px;
  .header {
    background-color: var(--color-latex30);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 18px 10px;
    text-align: center;
  }
  .bodyOrden {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 10px;
    padding: 20px 20px;
    width: 100%;
  }
`;
